module.exports = __webpack_public_path__ + "static/media/top-slide-2.5ce36311.webp";